import { useState } from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Reusable overlay for Build stages.
 * Shows once, can be re-read via ? icon.
 */
export default function StageOverlay({ children, onDismiss, mapTitle }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onDismiss} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg p-8">
        <div className="text-txt-primary text-base leading-relaxed space-y-4">
          {typeof children === 'string' ? <p>{children}</p> : children}
        </div>
        <button
          onClick={onDismiss}
          className="btn-gold mt-6 w-full text-center font-heading uppercase"
        >
          Got It
        </button>
      </div>
    </div>
  );
}

/**
 * Small ? icon that shows the stage directions in a popover.
 */
export function HelpIcon({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setOpen(!open)}
        className="w-6 h-6 rounded-full bg-white/80 border border-navy/10
          flex items-center justify-center text-txt-secondary hover:text-txt-primary
          hover:bg-white transition-colors"
        title="Show directions"
      >
        <HelpCircle className="w-4 h-4" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute top-8 left-0 z-50 bg-white rounded-xl shadow-xl border border-navy/10 p-5 w-80">
            <div className="text-sm text-txt-primary leading-relaxed space-y-3">
              {typeof children === 'string' ? <p>{children}</p> : children}
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-xs text-txt-secondary hover:text-txt-primary mt-3"
            >
              Close
            </button>
          </div>
        </>
      )}
    </div>
  );
}
